import React from 'react';

export function Badge({
  variant = 'brand',
  dot = false,
  icon = null,
  children,
  className = '',
  ...props
}) {
  const classes = [
    'bza-badge',
    `bza-badge-${variant}`,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <span className={classes} {...props}>
      {dot && <span className="bza-badge-dot" aria-hidden="true" />}
      {icon && <span className="bza-badge-icon">{icon}</span>}
      <span>{children}</span>
    </span>
  );
}

export default Badge;
